export default {
    name: 'contact',
    data() {
        return {
            dialogShow: false,
            imgUrl: "",
            siteStats: {
                网站运行天数: "--",
                文章总数: "--",
                分类总数: "--",
                访问总数: "--",
                评论总数: "--",
            }, //网站信息统计
            articleData: [], //随笔文章数据
            contributeData: [], //粉丝投稿数据
        }
    },
    created() {
        this.getArticleData();
        this.getStatis();
    },
    methods: {
        //链接跳转
        toPage(idx) {
            const { navList } = this;
            if (this.$route.path === navList[idx].url) return;
            this.navIdx == idx;
            this.$router.push(navList[idx].url);
            this.showTopNav = false;
        },

        //获取文章统计数据
        async getArticleData() {
            const { API, $request } = this;
            const url = API.getArticleData;
            const { data: res } = await $request(url, "get");
            const data = res.data || [];
            if (res.code != 200) return alert(res.msg);
            for (const item of data) {
                if (item.type == "0") {
                    this.articleData.push(item);
                } else {
                    this.contributeData.push(item);
                }
            }
        },

        //获取网站统计
        async getStatis() {
            const { API, $request } = this;
            const url = API.getSiteStats;
            const { data: res } = await $request(url, "get");
            if (res.code !== 200) return alert(res.msg);
            this.siteStats = res.data || {
                网站运行天数: "--",
                文章总数: "--",
                分类总数: "--",
                访问总数: "--",
                评论总数: "--",
            };
        },


        //图标点击
        handleIcon(type) {
            if (type == "wechat") {
                this.imgUrl = require("@/assets/images/me/wechat.jpg");
                this.dialogShow = true;
            } else if (type == "qq") {
                this.imgUrl = require("@/assets/images/me/QQ.jpg");
                this.dialogShow = true;
            } else {
                window.open(
                    "https://blog.csdn.net/weixin_43850458?spm=1000.2115.3001.5343",
                    "_blank"
                );
            }
        },
        //隐藏弹框
        hide() {
            this.dialogShow = false;
            this.imgUrl = "";
        },
    }
}